/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ItemsModule
 * @preferred
 */

import { NgModule } from '@angular/core';

import {
    createNgDependencyProviders,
} from 'ng/modules/data-model/utils/inject-ng-dependencies.utils';

import {
    AlbServicesSiteItem,
    AlertItem,
    AlertSyslogConfigItem,
    AvailabilityZoneItem,
    ClusterItem,
    ControllerBannerAlertItem,
    ControllerFault,
    ControllerSiteItem,
    CSRFPolicyItem,
    FileObjectItem,
    GSLB,
    GSLBVSItem,
    LicensePoolItem,
    LicenseUsage,
    Pool,
    PoolGroup,
    PoolGroupDeploymentPolicyItem,
    ReportItem,
    ReportProfileItem,
    ServiceEngineItem,
    SystemReportItem,
    TechSupportItem,
    TechSupportProfileItem,
    TenantSettingsItem,
    TenantUsageItem,
    TrustedHostProfileItem,
    UpgradeProfileItem,
    VirtualServiceItem,
    WafCrsItem,
} from './factories';

const providers = createNgDependencyProviders([
    AlbServicesSiteItem,
    AlertItem,
    AlertSyslogConfigItem,
    AvailabilityZoneItem,
    ClusterItem,
    ControllerBannerAlertItem,
    ControllerFault,
    ControllerSiteItem,
    CSRFPolicyItem,
    FileObjectItem,
    GSLB,
    GSLBVSItem,
    LicensePoolItem,
    LicenseUsage,
    Pool,
    PoolGroup,
    PoolGroupDeploymentPolicyItem,
    ReportItem,
    ReportProfileItem,
    ServiceEngineItem,
    SystemReportItem,
    TechSupportItem,
    TechSupportProfileItem,
    TenantSettingsItem,
    TenantUsageItem,
    TrustedHostProfileItem,
    UpgradeProfileItem,
    VirtualServiceItem,
    WafCrsItem,
]);

/**
 * @description
 * Module for registering Item files. Items can be imported by the 'items/*' path which points to
 * 'items/factories'. This module should contain providers only.
 * @author alextsg
 */
@NgModule({ providers })
export class ItemsModule {}
